<template>
	<section>

		<article>
			<article class="input-style">
				<slot name="searchUseYn"></slot>
				<div class="searchBox">
					<div>
						<label for="searchSelect" class="hidden">검색선택</label>
						<select id="searchSelect" v-model="searchCondition"
							style="margin-right: 20px; margin-left: 10px">
							<slot name="searchCondition"></slot>
						</select>
					</div>
					<div>
						<label for="searchInput" class="hidden" style="margin-right: 10px">검색입력창</label>
						<input type="text" title="검색어 입력" id="searchInput" placeholder="검색어입력" v-model="searchKeyword"
							@keyup.enter="emitSearch" />
					</div>
					<div><button class="btn dkGray" @click="emitSearch">검색</button></div>
				</div>
			</article>
		</article>
	</section>
</template>

<script>
export default {
	data() {
		return {
			dataPerPage: 10,
			searchCondition: 1,
			searchKeyword: null
		}
	},

	methods: {
		emitSearch() {
			this.$emit('emitSearch', this.searchCondition, this.searchKeyword);
		},

		emitPerChange() {
			this.$emit('emitPerChange', this.dataPerPage);
		}
	}
}
</script>

<style>

</style>